/* eslint-disable @typescript-eslint/no-explicit-any */
import { OidcService } from '@revenuewell/logic-oidc';
import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { Branch, CallHistoryReportRequest } from './types';

export default class CallService extends AuthApiService {
  private config: any;

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService());
    this.config = config;
    return this;
  }

  getCallToken = async (locationId: string | number) => {
    const url = `${this.config.legacyMessenger.apiUrl}/call/${locationId}/call-token`;
    const response = await this.authFetch(url);
    return await response.json();
  };

  getBranch = async (locationId: string | number): Promise<Branch> => {
    const url = `${this.config.legacyMessenger.apiUrl}/branch/${locationId}/get-branch`;
    const response = await this.authFetch(url);
    return await response.json();
  };

  getParentCallSid = async (callSid: string, locationId: string | number) => {
    const url = `${this.config.legacyMessenger.apiUrl}/call/${locationId}/${callSid}/get-parent-callsid`;
    const response = await this.authFetch(url);
    return await response.json();
  }

  reportCallAction = async (request: CallHistoryReportRequest) => {
    const url = `${this.config.legacyMessenger.apiUrl}/call-history/report-call-action`;
    await this.authFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request)
    });
  }
}
